<script>
export default {
  name: "audioPlay",
  data() {
    return {};
  },
  methods: {
    replaceMusic(selectItem, type, index, ref) {
      if (this.$refs.audioSet) {
        this.$refs.audioSet.pause();
      }
      if (this.$refs.audioDubSet) {
        this.$refs.audioDubSet.pause();
      }
      this.$store.commit("addSoundtrack/setSoundtrackState", {
        state: true,
        type: type,
        index: index,
        start: selectItem.timeSlot[0],
        end: selectItem.timeSlot[1],
        operation: "replace",
      });
    },

    formatDate(timestamp) {
      //日期
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      var h = date.getHours() + ":";
      var m = date.getMinutes() + ":";
      var s = date.getSeconds();
      return Y + M + D + h + m + s;
    },
    formatTime(duration) {
      //播放时长时间格式
      if (duration <= 0) return "00:00";
      if (!duration) return "--:--";
      var min = ~~(duration / 60);
      min = (min + "").length === 1 ? "0" + min : min;
      var sec = Math.round(duration % 60);
      sec = (sec + "").length === 1 ? "0" + sec : sec;
      min = min || "00";
      sec = sec || "00";
      return min + ":" + sec;
    },
    // 精确到毫秒
    millisecondFormat(duration) {
      duration=parseFloat(duration)
      if (duration <= 0) {
        return "00:00:00";
      }
      let second = 0; //秒
      let minute = 0; // 分
      let millisecond = "00"; //毫秒
      var num = duration.toFixed(2);
      var index = num.indexOf(".");
      if (index != -1) {
        millisecond = num.substring(index + 1, index + 3);
      }

      if (duration > 60) {
        minute = parseInt(duration / 60);
        second = parseInt(duration % 60);
      } else {
        second = parseInt(duration);
      }
      let result = "";
      if (minute < 10) {
        result = "0" + minute;
      } else {
        result = minute;
      }
      if (second < 10) {
        result += ":0" + second;
      } else {
        result += ":" + second;
      }
      result += ":" + millisecond;
      return result;
    },
    musicTimeConverter(duration) {
      let totalSecond = parseInt(duration); // 秒
      if (totalSecond <= 0) {
        return "00:00";
      }
      let second = 0;
      let minute = 0; // 分

      if (totalSecond > 60) {
        minute = parseInt(totalSecond / 60);
        second = parseInt(totalSecond % 60);
      } else {
        second = totalSecond;
      }
      let result = "";
      if (minute < 10) {
        result = "0" + minute;
      } else {
        result = minute;
      }

      if (second < 10) {
        result += ":0" + second;
      } else {
        result += ":" + second;
      }

      return result;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/emodal/templateLib/contents/audioPlay.vue